<script lang="ts">
    import {Route} from 'svelte-routing'
    import Home from "./home/Home.svelte"
    import About from "./about/About.svelte"
    import Games from "./games/Games.svelte"
    import Marketplace from "./marketplace/Marketplace.svelte"
    import MarketplaceActivity from "./marketplace-activity/Activity.svelte"
    import MarketplaceSeller from "./marketplace-seller/Seller.svelte"
    import Nft from "./nft/Nft.svelte"
    import Support from "./support/Support.svelte"
    import Token from "./token/Token.svelte"
    import Terms from "./terms/Terms.svelte"
    import Policy from "./policy/Policy.svelte"
    import Error404 from "./404/404.svelte"
    import Login from "./login/Login.svelte"
    import Register from "./register/Register.svelte"
    import Forgotten from "./forgotten/Forgotten.svelte"
    import Restore from "./restore/Restore.svelte"
    import Blog from "./blog/Blog.svelte"
    import Article from "./article/Article.svelte"
    import Unsubscribe from "./unsubscribe/Unsubscribe.svelte"
    import Referral from "./referral/Referral.svelte"
</script>

<Route path="/"><Home/></Route>
<Route path="about"><About/></Route>
<Route path="games"><Games/></Route>
<Route path="marketplace"><Marketplace/></Route>
<Route path="marketplace/activity"><MarketplaceActivity/></Route>
<Route path="marketplace/:userId" let:params><MarketplaceSeller userId={params.userId}/></Route>
<Route path="nft/:productId" let:params><Nft productId={params.productId}/></Route>
<Route path="support"><Support/></Route>
<Route path="token"><Token/></Route>
<Route path="terms"><Terms/></Route>
<Route path="policy"><Policy/></Route>
<Route path="login"><Login/></Route>
<Route path="delete/:hash" let:params><Login hash={params.hash}/></Route>
<Route path="2fa/:hash" let:params><Login twoFaHash={params.hash}/></Route>
<Route path="register"><Register/></Route>
<Route path="register/:hash" let:params><Register hash={params.hash}/></Route>
<Route path="forgotten"><Forgotten/></Route>
<Route path="restore/:hash" let:params><Restore hash={params.hash}/></Route>
<Route path="blog"><Blog/></Route>
<Route path="blog/:url" let:params><Article url={params.url}/></Route>
<Route path="unsubscribe/:data" let:params><Unsubscribe data={params.data}/></Route>
<Route path="r/:userId" let:params><Referral userId={params.userId}/></Route>
<Route><Error404/></Route>
